import { CustomerCollectionContactMethod } from 'TypeGen/AccountsReceivable/Collections/customer-collection-contact-method';

export const contactMethodOptions = [
  { ID: CustomerCollectionContactMethod.Unknown, Name: 'Not specified' },
  { ID: CustomerCollectionContactMethod.CustomerEmail, Name: 'Customer Email' },
  { ID: CustomerCollectionContactMethod.PhoneCall, Name: 'Phone Call' },
  { ID: CustomerCollectionContactMethod.SalespersonEmail, Name: 'Salesperson Email' },
  { ID: CustomerCollectionContactMethod.Website, Name: 'Website' },
  { ID: CustomerCollectionContactMethod.OPS, Name: 'OPS' },
  { ID: CustomerCollectionContactMethod.Other, Name: 'Other' },
];

export const formatContactMethod = (value: CustomerCollectionContactMethod) =>
  contactMethodOptions.find(x => x.ID === value)?.Name ?? 'Not specified';
